import React from "react";
import NavLight from "../components/NavLight";
import "./PrivacyPolicy.css";
import {Helmet} from "react-helmet";

function PrivacyPolicy() {
    return (
        <div className="PrivacyPolicy">
            <Helmet>
                <title>Magic Feedback.Privacy Policy </title>
                <meta
                    name="title"
                    content="Magic Feedback. Privacy Policy"
                />
                <meta name="description" content="Magic Feedback. Privacy Policy"/>
                <meta
                    property="og:title"
                    content="Magic Feedback. Privacy Policy"
                />
                <meta
                    property="og:description"
                    content="Magic Feedback. Privacy Policy"
                />
            </Helmet>
            <NavLight/>
            <section className="privacy-policy-container">
                <h1>Privacy Policy</h1>
                <p>
                    Last updated February 05, 2024
                    <p>&nbsp;</p>
                    This Privacy Policy, as amended or otherwise changed from time to time
                    (the "Privacy Policy" or “Policy”), explains the manner in which Magic
                    Feedback OÜ, 16772806, Harju maakond, Tallinn, Kesklinna linnaosa,
                    Tornimäe tn 5, 10145 (hereinafter "Magic Feedback OÜ" or the
                    “Company”) maintains and discloses user information obtained through
                    its website https://magicfeedback.io/ (the "Site"). The terms "we,"
                    "us," and "our" refer to the Company. By using the Site, you ("User")
                    consent to the data practices prescribed in this Privacy Policy.{" "}
                    <p>&nbsp;</p>
                    Your Personal Data is processed under this Privacy Policy and in
                    accordance with applicable legislation, including the General Data
                    Protection Regulation (2016/679) ("GDPR") and the applicable national
                    data protection laws (“Data Protection Law”). <p>&nbsp;</p>
                    The Company acts as data controllers of your Personal Data.
                    <p>&nbsp;</p>
                    On occasion, the Company may revise this Privacy Policy to reflect
                    changes in the law, our personal data collection and use practices,
                    the features on the Site, or advances in technology. If material
                    changes are made to this Privacy Policy, the changes will be
                    prominently posted on the Site.
                </p>
                <h2>What if I do not want to accept this Privacy Policy?</h2>
                <p>
                    By using this Site, you signify your acceptance of this Policy. If you
                    do not agree to this Policy, please do not use our Site. Your
                    continued use of the Site following the posting of changes to this
                    Policy will be deemed as your acceptance of those changes.{" "}
                    <p>&nbsp;</p>
                    In case you disclose any Personal Data regarding any third person
                    (e.g. your employee, management board member, co-worker, contracting
                    party, etc.) to us, you are obliged to refer them to this Policy.
                </p>
                <h2>What information does the Company collect?</h2>
                <p>
                    We collect Personal Data and Anonymous Data, as described below.{" "}
                    <p>&nbsp;</p>
                    We may collect Personal Data from you, such as:
                    <ul>
                        <li>first and last name</li>
                        <li> e-mail and mailing addresses</li>
                        <li>information about working status</li>
                        <li>gender</li>
                        <li>phone number</li>
                    </ul>
                    <p>&nbsp;</p>
                    If you provide us feedback or contact us via e-mail, we will collect
                    your name and e-mail address, as well as any other content included in
                    the e-mail, in order to send you a reply.
                </p>
                <h2>Some information is collected automatically by our servers:</h2>
                <p>
                    <ul>
                        <li>
                            Our servers (which may be hosted by a third-party service
                            provider) collect information from you, including your browser
                            type, operating system, Internet Protocol ("IP") address (a number
                            that is automatically assigned to your computer when you use the
                            Internet, which may vary from session to session), domain name,
                            and/or a date/time stamp for your visit.
                        </li>
                        <li>
                            As is true of most websites, we gather certain information
                            automatically and store it in log files. This information includes
                            IP addresses, browser type, Internet service provider ("ISP"),
                            referring/exit pages, operating system, date/time stamp, and
                            clickstream data.
                        </li>
                        <li>
                            Like many online services, we use cookies to collect information.
                            "Cookies" are small pieces of information that a website sends to
                            your computer's hard drive while you are viewing the website.
                        </li>
                        <li>
                            We retain information on your behalf, such as transactional data
                            and other session data linked to your account.
                        </li>
                        <li>
                            MagicFeedback use and transfer of information received from Google
                            APIs to any other app will adhere to {" "}
                            <a
                                href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
                                target="_blank" rel="noreferrer"
                            >
                                Google API Services User Data Policy
                            </a>
                            , including the Limited Use requirements.
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    We do not collect any Special Categories of Personal Data about you
                    (this includes details about your race or ethnicity, religious or
                    philosophical beliefs, sex life, sexual orientation, political
                    opinions, trade union membership, information about your health and
                    genetic and biometric data).
                </p>
                <h2>How does the Company use the information it collects?</h2>
                <p>
                    In general, Personal Data you submit is necessary for contacting you
                    in the context of the delivery of products or services and
                    administering such products and services. Also, we use your Personal
                    Data in the following ways:
                    <p>&nbsp;</p>
                    <ul>
                        <li>
                            Identify and perform identity verification through a service
                            provider
                        </li>
                    </ul>
                    <p>&nbsp;</p>
                    The Company does not sell user and/or Anonymous Data to any third
                    party.
                    <p>&nbsp;</p>
                    Marketing and newsletter subscriptions.
                    <p>&nbsp;</p>
                    We collect information about your behavior within the application to
                    offer you interesting information and offers regarding our services
                    and products. This information includes your profile information and
                    user status. This information is processed automatically and you as a
                    user will notice it by seeing more relevant content when signed in. We
                    do not share this information with third parties. The processing of
                    such personal data is based on our legitimate interest to develop and
                    promote our services and products. If you have subscribed to our
                    mailing list, we will send you information on our new activities,
                    events, and products. We can also send special offers directed to a
                    special user group, users of a certain region, etc. Adding you to our
                    mailing lists is based on your consent. You may also unsubscribe from
                    the mailing list anytime by clicking the unsubscribe link at the
                    bottom of each message.
                    <p>&nbsp;</p>
                    Customer support.
                    <p>&nbsp;</p>
                    In case you need to contact our customer support, our support
                    personnel will handle your contact information and the contents of
                    your communication. Please do not share any sensitive data in your
                    communication with our customer support. You can contact our customer
                    support through various means. Depending on the means of communication
                    you choose, we’ll process the following contact details: - Your IP
                    address (chat support) - Phone number (phone support, SMS support) -
                    Email (email support) - User ID of an instant messaging app (QR code,
                    support through an instant messaging app). We keep a record of the
                    contents of the support tickets to make sure that you receive quality
                    service and to develop our products and services. If you contact us by
                    calling our support number, please note that we also record the phone
                    calls for the same purposes. The processing of your personal data in
                    connection with your communication with our customer service is based
                    on the service agreement between you and the Company as well as our
                    legitimate interest to follow up on the quality of our customer
                    service, to verify the actions taken based on your request and to
                    develop our service in the future.
                </p>
                <h2>How does the Company share my Personal Data?</h2>
                <p>
                    It may be necessary to disclose your information to comply with any
                    law, court orders, or government request, defend against claims,
                    investigate or bring legal action against illegal or suspected illegal
                    activities, enforce our Terms, or protect the rights, safety, and
                    security of the Company, our users, or the public.
                    <p>&nbsp;</p>
                    We may share your Personal Data with third-party service providers to
                    provide you with the services that we offer you through our Site.
                    These third-party service providers are required not to use your
                    Personal Data other than to provide the services requested by you.
                    <p>&nbsp;</p>
                    Other than as stated in this Privacy Policy, the Company does not
                    disclose any of your personal information to third parties unless
                    required to do so by law enforcement, court order, or in compliance
                    with legal reporting obligations.
                    <p>&nbsp;</p>
                    All third-party service providers that we share your data with shall
                    be requested to only process your data in accordance with instructions
                    from us and comply fully with this Privacy Policy, any applicable data
                    protection laws and any other appropriate confidentiality and security
                    measures. We may also share your personal data with competent
                    authorities when this is necessary to comply with a legal obligation,
                    court order or comparable ocial order issued by an authorized
                    Authority.
                    <p>&nbsp;</p>
                    We may share some or all of your Personal Data in connection with or
                    during negotiation of any merger, financing, acquisition or
                    dissolution transaction or proceeding involving sale, transfer,
                    divestiture, or disclosure of all or a portion of our business or
                    assets. In the event of an insolvency, bankruptcy, or receivership,
                    Personal Data may also be transferred as a business asset.
                    <p>&nbsp;</p>
                    If another company acquires our company, business, or assets, that
                    company will possess the Personal Data collected by us and will assume
                    the rights and obligations regarding your Personal Data as described
                    in this Privacy Policy.
                    <p>&nbsp;</p>
                    The Site may contain links to other third-party websites which are
                    regulated by their own privacy policies. The Company is not
                    responsible for the privacy policies of these third-party websites
                    even if they were accessed using the links from our site.
                </p>
                <h2>Cookie policy</h2>
                <p>
                    Our website uses cookies to distinguish you from other users and to remember you either for the
                    duration of your visit (a ‘session cookie’) or for repeat visits (a ‘persistent cookie’).
                    This helps us to provide you with a good experience when you browse our website and also allows us
                    to improve our site.
                    <p>&nbsp;</p>
                    A cookie is a small file of letters and numbers that we store on your browser or the hard drive of
                    your computer if you agree.
                    Cookies contain information that is transferred to your computer's hard drive.
                    They may be set by the website you are visiting or by third parties who provide content or services
                    for that site.
                    We and the third parties we work with use cookies and similar tracking technologies to collect
                    information about your use of the Services, such as your IP address, browser type, browser version,
                    pages viewed, time spent on pages, links clicked and conversion information.
                    This information may be used by us and others to, among other things, analyze and track data,
                    determine the popularity of certain content, deliver advertising and content targeted to your
                    interests on the Services and other websites, provide customer support,
                    troubleshoot issues with and improve the operation of our Website and Services, and better
                    understand your online activity.
                    The third parties used in connection with our site may include, for example, advertising networks
                    and providers of external services like web traffic analysis services.
                    <p>&nbsp;</p>
                    You can find more information about the individual cookies we use and the purposes for which we use
                    them in the list below:
                    <p>&nbsp;</p>
                    <ul>
                        <li>Google Analytics: For website analytics and user behavior analysis.</li>
                        <li>LinkedIn Ads: For targeted advertising on LinkedIn.</li>
                        <li>Facebook Ads: For targeted advertising on Facebook.</li>
                        <li>Google Ads: For online advertising through the Google platform.</li>
                        <li>Mouseflow: For analyzing user behavior on our website/application.</li>
                        <li>Leadfeeder: For lead generation and analyzing website traffic.</li>
                    </ul>
                    <p>&nbsp;</p>
                </p>

                <h2>How long do we store your personal data?</h2>
                <p>
                    We keep the data you have provided to us on your user account for the
                    whole period of your customer relationship and as long as it is
                    necessary with regard to the purposes of the processing described
                    above.
                </p>
                <h2>What legal rights do you have in relation to your information?</h2>
                <p>
                    Under certain circumstances, you have the following rights under data
                    protection laws in relation to your personal data:
                    <ul>
                        <li>Request access to your personal data</li>
                        <li>Request correction of your personal data.</li>
                        <li>Request erasure of your personal data.</li>
                        <li>Object to processing of your personal data.</li>
                        <li>Request restriction of processing your personal data.</li>
                        <li>Request transfer of your personal data.</li>
                        <li>Right to withdraw consent.</li>
                    </ul>
                    You also have the right to lodge a complaint with a Data Protection
                    Authority (“DPA”) if you think that your Personal Data is being
                    processed incorrectly or your rights have been violated by the
                    Company. The Estonian Data Protection Inspectorate is available at
                    http://www.aki.ee/en.
                </p>
                <h2>Contact us</h2>
                <p>
                    If you have any questions, comments, or requests regarding this privacy policy, or if you need to
                    raise a complaint concerning your personal data, please contact us at info@magicfeedback.io.
                </p>
            </section>
        </div>
    );
}

export default PrivacyPolicy;
